// constants
import { MAX_ALLOWED_USERS } from './membersTable.constants'

// helpers
import { getFirstName, getLastName } from '../../../../../../helpers/users'
import { accessNestedProperty } from '../../../../../../helpers/general'

const getSelectedMemberIds = (selectedMembers) =>
  selectedMembers.map((member) => member?.value)

export const getMemberIds = (members = []) =>
  members.map((member) => member?.value)

export const getUserIds = (users = []) => users.map((user) => user?.id)

export const isMemberSelected = (selectedMemberId, selectedMembers = []) => {
  const selectedMemberIds = getSelectedMemberIds(selectedMembers)
  return selectedMemberIds.includes(selectedMemberId)
}

export const areAllMembersChecked = (users = [], selectedMembers = []) => {
  if (users.length > 0) {
    return users.every((user) => isMemberSelected(user.id, selectedMembers))
  }
  return false
}

export const createMember = (user = {}) => ({
  value: user.id,
  display: `${getFirstName(user)} ${getLastName(user)}`,
})

export const getSelectedMembersWithOutSelectedMemberId = (
  selectedMembers,
  selectedMemberId
) => {
  const filteredSelectedMembers = selectedMembers.filter(
    (selectedMember) => selectedMember?.value !== selectedMemberId
  )
  return filteredSelectedMembers
}

export const shouldDisableSelectAll = ({
  users = [],
  selectedMembers = [],
  getSelectedMembersCount,
  group = []
}) => {
  const isAnyUserInGroup = users && users.length > 0 && users.some((user) =>
    group.members.some((groupUser) => groupUser.email === user.userName)
  )

  const usersCount = users.length
  const selectedMembersCount = getSelectedMembersCount(selectedMembers)
  const allMembersChecked = areAllMembersChecked(users, selectedMembers)
  if (
    isAnyUserInGroup ||
    selectedMembersCount >= MAX_ALLOWED_USERS ||
    (usersCount > MAX_ALLOWED_USERS - selectedMembersCount &&
      !allMembersChecked)
  ) {
    return true
  }
  return false
}

export const shouldDisableUser = ({
  user,
  selectedMembers = [],
  getSelectedMembersCount,
  group = [],
}) => {
  const isInGroup = group?.members.some(
    (groupUser) => groupUser.email === user.userName
  )
  if (isInGroup) {
    return true
  }

  const selectedMembersCount = getSelectedMembersCount(selectedMembers)
  if (
    selectedMembersCount >= MAX_ALLOWED_USERS &&
    !isMemberSelected(user?.id, selectedMembers)
  ) {
    return true
  }
  return false
}

const SORT_BY_MAP = {
  firstName: 'name.givenName',
  lastName: 'name.familyName',
}

export const sortUsers = ({ users = [], sortBy, sortOrder }) =>
  [...users].sort((a, b) => {
    const isAsc = sortOrder === 'asc'
    return isAsc
      ? accessNestedProperty(a, SORT_BY_MAP[sortBy]).localeCompare(
          accessNestedProperty(b, SORT_BY_MAP[sortBy])
        )
      : accessNestedProperty(b, SORT_BY_MAP[sortBy]).localeCompare(
          accessNestedProperty(a, SORT_BY_MAP[sortBy])
        )
  })
